import { render, staticRenderFns } from "./AccidentIncidentReport.vue?vue&type=template&id=0f833dca&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./AccidentIncidentReport.vue?vue&type=script&lang=js&"
export * from "./AccidentIncidentReport.vue?vue&type=script&lang=js&"
import style0 from "./AccidentIncidentReport.vue?vue&type=style&index=0&id=0f833dca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f833dca",
  null
  
)

export default component.exports